import axios from "axios";
import config from "../../config";
import CryptoJS from 'crypto-js'
import { getUnixTime } from "date-fns";

const client = axios.create({
	baseURL: config.baseApiUrl
})

client.interceptors.request.use(function (request) {
	const timestamp = getUnixTime(new Date()),
			userId = localStorage.getItem('u')

	request.headers['user-id'] = userId
	request.headers['hmac-timestamp'] = timestamp
	request.headers['hmac-signature'] = CryptoJS.HmacSHA256(`${userId}_${timestamp}`, localStorage.getItem('t')!)
	return request
})

export default client;